export const ENGLISH = 'en';

